import { HttpClient } from '@angular/common/http';
import { Company } from '../app/company/company.model';

export abstract class Entity {
  public url: string;
  public entityName: string;
  public childEntitiesNames: string[];

  constructor(public http: HttpClient, url: string, entityName: string) {
    this.url = url;
    this.entityName = entityName;
  }

  public Create(params: any) {
    // działa dla company
    return this.http.post(this.url + this.entityName + '/', params);
  }


  public Update(id: number, params: any) {
    // działa dla company
    return this.http.put(this.url + this.entityName + '/' + id, params);
  }

  public GetAll() {
    // działa dla company
    return this.http.get(this.url + this.entityName);
  }

  public GetOne<T>(id: number) {
    // działa dla company
    return this.http.get<T>(this.url + this.entityName + '/' + id);
  }


  public Delete(id: number) {
    // działa dla company
    return this.http.delete(this.url + this.entityName + '/' + id);
  }
}
